import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../components/Loader';
import { getRewards, updateReward } from '../../actions/settings';
import { LocalForm, Control } from 'react-redux-form';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Grid, Typography, Button } from '@mui/material';
import { Col, FormGroup } from 'reactstrap';
import { withStyles } from '@material-ui/core/styles';
import Switch from '@mui/material/Switch';
import {
    weekendPointField,
    rewardPointField,
    notValidPoints,
} from '../../utilities/message'
import Match from '../../utilities/validation'
import Errors from '../../components/common/errors'

const CustomSwitch = withStyles((theme) => ({
    switchBase: {
        '&$checked': {
            color: '#442580',
        },
        '&$checked + $track': {
            backgroundColor: '#442580',
        },
    },
    checked: {},
    track: {},
}))(Switch);

const RewardManagement = () => {
    const loaders = useSelector((state) => state.loader);
    const rewardData = useSelector((state) => state.rewards);

    const [isWeekend, setIsWeekend] = useState(rewardData?.rewards?.is_weekend);
    const [weekendPoints, setWeekendPoints] = useState(rewardData?.rewards?.weekend_points);
    const [isReward, setIsReward] = useState(rewardData?.rewards?.is_reward);
    const [rewardPoints, setRewardPoints] = useState(rewardData?.rewards?.reward_points);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getRewards(null, (res) => {
            if (res) {
                setIsWeekend(rewardData?.rewards?.is_weekend);
                setWeekendPoints(rewardData?.rewards?.weekend_points);
                setIsReward(rewardData?.rewards?.is_reward);
                setRewardPoints(rewardData?.rewards?.reward_points);
            }
        }));
    }, [dispatch]);

    const handleAddSubmit = () => {
        const data = {
            is_weekend: isWeekend,
            weekend_points: weekendPoints,
            is_reward: isReward,
            reward_points: rewardPoints,
        };

        dispatch(updateReward(data, (res) => {
            if (res) {
                dispatch(getRewards({}, () => { }));
            }
        }));
    };

    const handleWeekendToggle = (checked) => {
        checked ? setIsWeekend('1') : setIsWeekend('0') && setWeekendPoints('0')
    };

    const handleRewardToggle = (checked) => {
        checked ? setIsReward('1') : setIsReward('0')
    };

    useEffect(() => {
        setIsWeekend(rewardData?.rewards?.is_weekend);
        setWeekendPoints(rewardData?.rewards?.weekend_points);
        setIsReward(rewardData?.rewards?.is_reward);
        setRewardPoints(rewardData?.rewards?.reward_points);
    }, [rewardData])

    return (
        <div>
            <Loader loading={loaders.isFetching} />
            <div style={{ display: 'flex' }}>
                <div>
                    <Typography variant="h4">Reward</Typography>
                    <Typography variant="subtitle1">Enable & Manage Rewards</Typography>
                </div>
            </div>

            <LocalForm model="user" onSubmit={(values) => handleAddSubmit(values)} style={{ marginTop: '40px' }}>
                <Grid container spacing={3}>

                    <Grid item xs={12} sm={6}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <CustomSwitch
                                        checked={isReward == '1'}
                                        onChange={(e) => handleRewardToggle(e.target.checked)}
                                        color='primary'
                                    />
                                }
                                label="Enable Registration Points"
                            />
                        </FormGroup>
                        <FormGroup>
                            <Control.text
                                className="form-control stateField input-field"
                                model="user.reward_points"
                                id="user.reward_points"
                                placeholder="Registration Points"
                                value={rewardPoints}
                                onChange={(e) => setRewardPoints(e.target.value)}
                                disabled={isReward == '0'}
                                errors={isReward == '1' ? {
                                    rewardPointField: (val) => !val,
                                    notValidPoints: (val) => val && !Match.validateNumbers(val),
                                } : {}}
                                style={{ color: isReward == '1' ? '' : 'grey' }}
                            />
                            {isReward == '1' && (
                                <Errors
                                    model="user.reward_points"
                                    errors={{
                                        rewardPointField,
                                        notValidPoints
                                    }}
                                    wrap={true}
                                />
                            )}
                        </FormGroup>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <CustomSwitch
                                        checked={isWeekend == '1'}
                                        onChange={(e) => handleWeekendToggle(e.target.checked)}
                                        color='primary'
                                    />
                                }
                                label="Enable Weekend Points"
                            />
                        </FormGroup>
                        <FormGroup>
                            <Control.text
                                model="user.weekend_points"
                                className="form-control stateField input-field"
                                id="user.weekend_points"
                                placeholder="Weekend Points"
                                value={weekendPoints}
                                onChange={(e) => setWeekendPoints(e.target.value)}
                                disabled={isWeekend == '0'}
                                errors={isWeekend == '1' ? {
                                    weekendPointField: (val) => !val,
                                    notValidPoints: (val) => val && !Match.validateNumbers(val),
                                } : {}}
                                style={{ color: isWeekend == '1' ? '' : 'grey' }}
                            />
                            {isWeekend == '1' && (
                                <Errors
                                    model="user.weekend_points"
                                    errors={{
                                        weekendPointField,
                                        notValidPoints
                                    }}
                                    wrap={true}
                                />
                            )}
                        </FormGroup>
                    </Grid>

                </Grid>
                <div className="updateBtn" style={{ textAlign: 'center', marginTop: '100px' }}>
                    <button type="submit">
                        Update Points
                    </button>
                </div>
            </LocalForm>
        </div>
    );
}

export default RewardManagement;

// , maxWidth: '400px', marginLeft:'235px'
